import { IntakeList } from '@/features/regulatory-intake/intake-list';

const RegulatoryIntakeListPage = () => {
  return <IntakeList />;
};

export default RegulatoryIntakeListPage;
